import React from 'react';
import {
  Box,
  Table as ChakraTable,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from '@chakra-ui/react';

const SeriesTable = ({ data }) => (
  <Box as={TableContainer} border='1px solid' borderColor='gray.100' mb={20}>
    <ChakraTable variant='striped'>
      <Thead>
        <Tr>
          {data[0].cells.map((cell, index) => (
            <Th key={`th-${cell}-${index}`} maxWidth='6.25rem' style={{ textWrap: 'wrap' }}>
              {cell}
            </Th>
          ))}
        </Tr>
      </Thead>
      <Tbody>
        {data.slice(1).map((row, index) => (
          <Tr key={`tr-${row}-${index}`}>
            {row.cells.map((cell) => (
              <Td key={cell}>{cell === '' ? '-' : cell}</Td>
            ))}
          </Tr>
        ))}
      </Tbody>
    </ChakraTable>
  </Box>
);

function Table({ series }) {
  return series.map((series) => <SeriesTable key={series._key} data={series.data.rows} />);
}

export default Table;
